import React, { useEffect, useState } from "react";
import "./Products.css";
import AboutCard from "../Card/AboutCard";
import { useAppContext } from "../../contexts/AppContext";
import axios from "axios";
import parse from "html-react-parser";

function Products() {
  const [ProductList, setProductList] = useState([]);
  const [productInformation, setProductInformation] = useState([]);
  const { backendUrl, translate } = useAppContext();
  const route = "/Product";
  const productListRoute = "/ProductList";

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const response = await axios.get(`${backendUrl}${route}`);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setProductInformation(response.data);
        }

        const productListResponse = await axios.get(`${backendUrl}${productListRoute}`);
        if (Array.isArray(productListResponse.data)) {
          setProductList(productListResponse.data);
        }
      } catch (error) {
        console.error("Error fetching product content:", error);
      }
    };
    fetchProductData();
  }, [backendUrl]);

  return (
    <div className="product-container animated">
      <div className="p-2">
        {Array.isArray(productInformation) && productInformation.length > 0 &&
          productInformation.map((productInfo, index) => (
            <div key={index} className="text-container">
              <div className="title-container d-block justify-content-center">
                <div className="service-title-container">
                  <div>
                    <h1>
                      {productInfo.title && parse(translate(productInfo.title))}
                    </h1>
                    <div className="title-underlined"></div>
                  </div>
                </div>
                <div className="d-flex w-100 justify-content-center">
                  <p style={{ fontWeight: "400" }}>
                    {productInfo.content && parse(translate(productInfo.content))}
                  </p>
                </div>
              </div>
            </div>
          ))}

        <AboutCard
          CardItem={ProductList}
          apiEndPoint={backendUrl}
          apiRoute={productListRoute}
          image="photo"
          profile="True"
          title="Doctors"
        />
      </div>
    </div>
  );
}

export default Products;
